import React, { useContext, useEffect } from "react";
import IOrder from "@models/IOrder";
import IOrder_Progress_State from "@models/IOrder_Progress_State";
import { SocketContext } from "@contexts/SocketContext";
import VendorContext from "@contexts/VendorContext";
import SupplierContext from "@contexts/SupplierContext";
import UserContext from "@contexts/UserContext";
import IUiSocketSetup from "@models/IUiSocketSetup";
import EndpointsEnum from "@models/EndpointsEnum";
import IStripeOnCreateSupplierVendorSetupIntentDTO from "@models/DTO/IStripeOnCreateSupplierVendorSetupIntentDTO";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import IStripeCreateSupplierVendorSetupIntentDTO from "@models/DTO/IStripeCreateSupplierVendorSetupIntentDTO";
import { StripeForm } from "./StripeForm/StripeForm";

type Props = {
    orderModel: IOrder;
    cancelFn: (refresh?: boolean) => void;
    confirmFn: (refresh?: boolean) => void;
    nextStep?: IOrder_Progress_State;
};

export const OrderPaymentStripe = (props: Props) => {
    const userModel = useContext(UserContext)!;
    const supplierModel = useContext(SupplierContext)!;
    const vendorModel = useContext(VendorContext)!;
    const socket = useContext(SocketContext)!;

    // const stripeHook = useStripe();
    // const elements = useElements();

    const [paymentElement, setPaymentElement] = React.useState<any>(null);
    const [clientSecret, setClientSecret] = React.useState<string | undefined>("");
    const [customerSessionClientSecret, setCustomerSessionClientSecret] = React.useState<string | undefined>("");
    const [stripe, setStripe] = React.useState<Promise<Stripe | null> | null>(null);
    const stripeKey = supplierModel.Supplier_Integration.stripe_publishable_api_key;

    const createSupplierVendorSetupIntent = async () => {
        const payload: IStripeCreateSupplierVendorSetupIntentDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            toBeCustomerVendorGuid: props.orderModel.Vendor!.guid,
            orderGuid: props.orderModel.guid,
        };

        if (userModel.isSupplierUser) {
            payload.vendorGuid = vendorModel.guid;
        }

        socket.emit(EndpointsEnum.StripeCreateSupplierVendorSetupIntent, payload);
    };

    const onCreateSupplierVendorSetupIntent = async (data: IStripeOnCreateSupplierVendorSetupIntentDTO) => {
        setClientSecret(data.client_secret);
        setCustomerSessionClientSecret(data.customer_session_client_secret);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.StripeOnCreateSupplierVendorSetupIntent, fn: onCreateSupplierVendorSetupIntent },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        createSupplierVendorSetupIntent();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        if (stripeKey) {
            setStripe(loadStripe(stripeKey));
        }
    }, [clientSecret]);

    return (
        <div className={"OrderPaymentStripe"}>
            {clientSecret && stripe ? (
                <Elements stripe={stripe} options={{ clientSecret, customerSessionClientSecret }}>
                    <StripeForm order={props.orderModel} />
                </Elements>
            ) : null}
        </div>
    );
};
